
import { Component, Vue } from 'vue-property-decorator';
import { getDiscountTypeList } from '@/api/reservationDiscountType';
import {
  addReservationItem,
  defaultReservationItem,
  getReservationItem,
  updateReservationItem,
} from '@/api/reservationItem';
import { ReservationItemModule } from '@/store/modules/reservationItem';
import { getReservationCategoryList } from '@/api/reservationCategory';
import { getFieldTypeList } from '@/api/reservationClientFieldType';
import { getServiceTermsList } from '@/api/serviceTerms';
import Basic from './components/Basic.vue';
import Basic2 from './components/Basic2.vue';
import ApplicantInfo from './components/ApplicationInfo.vue';
import Charge from './components/Charge/index.vue';
import Discount from './components/Discount.vue';
import RefundRules from './components/RefundRules.vue';
import DeliveryInfo from './components/DeliveryInfo.vue';
import RefundInfo from './components/RefundInfo.vue';
import ReserveManage from './components/ReserveManage.vue';
import PaymentInfo from './components/PaymentInfo.vue';
import ServiceTerms from './components/ServiceTerms.vue';
import AncillaryFacility from './components/AncillaryFacility.vue';
import { UserModule } from '@/store/modules/user';

@Component({
  components: {
    Basic,
    Basic2,
    ApplicantInfo,
    Charge,
    Discount,
    RefundRules,
    DeliveryInfo,
    RefundInfo,
    ReserveManage,
    PaymentInfo,
    ServiceTerms,
    AncillaryFacility,
  },
})
export default class extends Vue {
  get form() {
    return ReservationItemModule.form;
  }

  get industry() {
    return UserModule.industry;
  }

  mounted() {
    if (this.$route.params.tab) this.tabDefault = 'charge';
    this.setForm();
  }

  destroyed() {
    ReservationItemModule.setForm(defaultReservationItem());
    ReservationItemModule.setScheduleType(null);
  }

  private loading = true;

  private tabDefault = 'basic';

  private typeUid = '';

  private listQuery: any = {
    typeUid: '',
    categoryUid: '',
    searchType: 'name',
    searchValue: '',
    page: 0,
    size: 10,
  }

  private categoryList: any = [];

  private handleCancel() {
    this.$router.push({ name: 'ReserveItem', query: { ...this.$route.query } });
  }

  private async handleSave() {
    await this.convertRanges();
    await this.convertHolidays();

    let valid = await this.validateForm('basicForm', 'form', 'basic');
    if (valid && this.industry !== 4 && this.industry !== 5 && this.industry !== 6) valid = await this.validateForm('chargeForm', 'form', 'charge');
    // if (valid) valid = await this.validateForm('ancillaryFacility', 'form', 'ancillaryFacility');

    if (valid) {
      this.loading = true;
      if (this.$route.params.uid) {
        updateReservationItem(this.$route.params.uid, this.form).then(() => {
          this.$message.success('성공적으로 예약 서비스를 수정했습니다.');
          this.$router.push({ name: 'ReserveItem', query: { ...this.$route.query } });
          this.loading = false;
        });
      } else {
        addReservationItem(this.form).then(() => {
          this.$message.success('성공적으로 예약 서비스를 등록했습니다.');
          this.$router.push({ name: 'ReserveItem', query: { ...this.$route.query } });
          this.loading = false;
        });
      }
    }
  }

  /* eslint-disable */
  private async setForm() {
    if (this.$route.params.uid) {
      ReservationItemModule.setIsNew(false);
      getReservationItem(this.$route.params.uid).then((res) => {
        ReservationItemModule.setForm(res.data);
        this.form.openRanges = this.getOpenRanges(res.data.ranges);
        this.form.holidays = this.parseHolidays(res.data.holidays);
        this.getCategoryList(res.data.typeUid);
        if (!res.data.managePolicy) {
          this.form.managePolicy = defaultReservationItem().managePolicy;
        }
        if (res.data.serviceTermsList.length === 0) {
          this.initServiceTermsList();
        }
        ReservationItemModule.setForm(this.form);
        this.loading = false;
      });
    } else {
      ReservationItemModule.setIsNew(true);
      if (this.$route.query.typeUid) {
        this.getCategoryList(this.$route.query.typeUid as string);
        const defaultForm = defaultReservationItem();
        defaultForm.typeUid = this.$route.query.typeUid as string;
        defaultForm.limit = 0;
        await ReservationItemModule.setForm({ ...defaultForm });
        this.initDiscountPolicies();
        this.initClientFieldType();
        this.initServiceTermsList();
        this.loading = false;
      } else {
        this.$message.warning('잘못된 접근입니다.');
        this.$router.push({ name: 'ReserveItem' });
      }
    }
  }
  /* eslint-enable */

/* eslint-disable */
  private async convertRanges() {
    this.form.ranges = [];
    (this.form.openRanges as any).forEach((openRange: any) => {
      const rangeDto: any = {
        uid: openRange.uid || '',
        reserveStart: openRange.reserve[0],
        reserveEnd: openRange.reserve[1],
        useStart: openRange.use[0],
        useEnd: openRange.use[1],
      };
      (this.form.ranges as any[]).push(rangeDto);
    });
  }
  /* eslint-enable */

  private getCategoryList(typeUid: string) {
    getReservationCategoryList(typeUid).then((res) => {
      this.categoryList = res.data;
    });
  }

  private getOpenRanges(ranges: any[]) {
    const openRanges: any[] = [];
    ranges.forEach((range: any) => {
      const openRange = {
        uid: range.uid,
        reserve: [range.reserveStart, range.reserveEnd],
        use: [range.useStart, range.useEnd],
      };
      openRanges.push(openRange);
    });
    return openRanges;
  }

  private async convertHolidays() {
    (this.form.holidays as any).forEach((holiday: any, index: number) => {
      (this.form.holidays[index] as any) = {
        ...holiday,
        startDate: holiday.dateRange[0],
        endDate: holiday.dateRange[1],
      };
    });
  }

  private parseHolidays(holidays: any[]) {
    const convertedHolidays: any[] = [];
    holidays.forEach((holiday: any) => {
      const convertHoliday = {
        ...holiday,
        dateRange: [holiday.startDate, holiday.endDate],
      };
      convertedHolidays.push(convertHoliday);
    });
    return convertedHolidays;
  }

  /* eslint-disable */
  private initDiscountPolicies() {
    getDiscountTypeList().then((res) => {
      res.data.forEach((type: any) => {
        (this.form.discountPolicies as any[]).push({
          typeCode: type.code,
          title: type.title,
          description: '',
          weekday: 0,
          weekend: 0,
          holiday: 0,
          useStatus: false,
          apiUseStatus: type.code != '101',
          additionStatus: false,
        });
      });
    });
  }
  /* eslint-enable */

  private initClientFieldType() {
    getFieldTypeList().then((res) => {
      res.data.forEach((type: any) => {
        (this.form.clientFields as any[]).push({
          fieldCode: type.code,
          name: type.name,
          viewOrder: type.viewOrder,
          requiredStatus: true,
          useStatus: true,
        });
      });
    });
  }

  private initServiceTermsList() {
    getServiceTermsList().then((res) => {
      res.data.forEach((terms: any) => {
        (this.form.serviceTermsList as any[]).push({
          termsUid: terms.uid,
          title: terms.title,
          content: '',
          useStatus: false,
        });
      });
    });
  }

  /**
   * tabRef: 탭 콘텐츠 ref명
   * formRef: 콘텐츠ref 속 form ref명
   * tabName: 탭 값
   */
  private async validateForm(tabRef: string, formRef: string, tabName: string) {
    return new Promise((resolve: any) => {
      (this.$refs[tabRef] as any).$refs[formRef].validate().then((valid: boolean) => {
        resolve(true);
      }).catch(() => {
        this.tabDefault = tabName;
        resolve(false);
      });
    });
  }
}
